var _defs, _g, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftIn(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.24 45.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#5a29b3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M22.62,0C10.13,0,0,10.13,0,22.62s10.13,22.62,22.62,22.62,22.62-10.13,22.62-22.62S35.11,0,22.62,0Zm14.34,22.48c.02,.15,.01,.29-.02,.42v.04l-.05,.11c-.04,.1-.12,.22-.22,.32l-10.88,10.6c-.19,.19-.45,.29-.73,.29s-.55-.11-.75-.31c-.4-.41-.39-1.07,.02-1.47l9.05-8.81H9.3c-.57,0-1.04-.47-1.04-1.04s.47-1.04,1.04-1.04h24.08l-9.05-8.81c-.41-.4-.42-1.06-.02-1.47,.4-.41,1.06-.42,1.47-.02l10.95,10.67c.08,.09,.16,.23,.2,.4l.02,.12-.49,.07,.49-.07Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIn);
export default __webpack_public_path__ + "static/media/left-in.05ced92145e09ea1989904fc3184dec6.svg";
export { ForwardRef as ReactComponent };